<template>
  <span>
    <span v-if="isShowDefault && (isNullUndefined(amount) || amount === '')">
      <slot name="default">
        <span>{{ defaultLabel }}</span>
      </slot>
    </span>

    <!-- &rlm; 强制文字从左到右，AED 阿联酋的符号是从右到左，导致显示顺序混乱 -->
    <span v-else>
      {{ currencySymbolInner }}{{ $utils.commaNum(amountPowered || 0, precision) }}&rlm;
    </span>
  </span>
</template>

<script>
import { getCurrencySymbol } from '@/services/utils/index'

export default {
  name: 'AmountShow',
  props: {
    // 货币符号，比currencyCode优先级高
    currencySymbol: {
      type: String
    },
    // 货币code,可以转换成 currencySymbol
    currencyCode: {
      type: String,
      default: 'USD'
    },
    // 金额
    amount: {
      type: [Number, String]
    },
    // 精度
    precision: {
      type: Number,
      default: 2
    },
    // 是否显示默认值
    isShowDefault: {
      type: Boolean,
      default: false
    },
    // amount 未提供的时候，默认显示
    defaultLabel: {
      type: String,
      default: '-'
    },
    // 金额转换倍数
    power: {
      type: [Number, String],
      default: 1
    }
  },
  computed: {
    currencySymbolInner() {
      if (this.currencySymbol) {
        return this.currencySymbol
      }
      // 尝试使用currencyCode转换
      return this.currencyCode ? getCurrencySymbol(this.currencyCode) : ''
    },
    amountPowered() {
      return Number(this.amount) * Number(this.power)
    }
  },
  methods: {
    isNullUndefined(val) {
      return val === undefined || val === null
    }
  }
}
</script>
